import BackstageComment from './BackstageComment.interface';
import { NftBid } from './NftBid.interface';
import { UserData } from './UserData.interface';

export default interface NftData {
  id: number;
  username: string;
  title: string;
  reservedBid: number;
  timeLeft?: string;
  image: string;
  description: string;
  views: number;
  createdAt: Date;
  updatedAt?: Date;
  comments: BackstageComment[];
  user: UserData;
  muted?: boolean;
  likes: number[];
  isVertical: boolean;
  poster: string;
  watermarkSrc?: string;
  categories: NftType[];
  endsAt?: Date;
  highestBid?: NftBid;
  bids?: NftBid[];
  video: string;
  audio: string;
  tokenId: string;
  contractAddress: string;
}

export interface INftForm {
  title: string;
  description: string;
  image?: any;
  username?: string;
  isVertical?: boolean;
  poster?: any;
  watermark?: boolean;
  watermarkSrc?: string;
  categories?: NftType[];
  reservedBid: number;
  ipfsMetaDataUrl?: string;
  ipfsVideoUrl?: string;
}

export interface INftState {
  nfts?: NftData[];
  userNfts?: NftData[];
  loading: boolean;
  nftIndex: number;
  preferredCategories?: NftType[];
}

export enum NftType {
  trading = 0,
  utility = 1,
  virtual = 2,
  art = 3,
  collectibles = 4,
  domains = 5,
  music = 6,
  photography = 7,
  sports = 8,
}

// export enum NftType {
//   trading = 'trading',
//   utility = 'utility',
//   virtual = 'virtual',
//   art = 'art',
//   collectibles = 'collectibles',
//   domains = 'domains',
//   music = 'music',
//   photography = 'photography',
//   sports = 'sports',
// }
